export enum MasterTypeInternetConnection {
  ETHERNET = 'ethernet',
  PLC_MYLIGHT = 'plc_mylight',
  GSM = 'gsm',
  WIFI = 'wifi',
  PLC_OTHER = 'plc_other'
}
